import React, { Component } from 'react'

export default class NavigatorResultChecker extends Component {
  constructor (props) {
    super(props)

    this.state = {
      accountCheck: props.account
    }
  }

  _accountCheck () {
    var value = this.state.accountCheck
    if (value === undefined || value === '') return

    this.setState({
      showAccountInput: false,
      accountCheck: '',
      emailAccount: value,
      submissionKey: null
    })
    this.props.history.push('/result?email=' + value)
  }

  _handleMyResultsOnClick () {
    if (this.props.authUser !== undefined && this.props.authUser !== null) {
      this.props.history.push('/result?email=' + this.props.authUser.email)
    } else {
      this.setState({showAccountInput: true})
    }
  }

  render () {
    let paypalDonationButton = () =>
      <form action='https://www.paypal.com/cgi-bin/webscr' method='post' target='_top'
        style={{ display: 'flex', alignItems: 'center', margin: '0 20px'}}>
        <input type='hidden' name='cmd' value='_s-xclick' />
        <input type='hidden' name='encrypted' value='-----BEGIN PKCS7-----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-----END PKCS7-----' />
        <input type='image' src='https://www.paypalobjects.com/en_US/i/btn/btn_donate_SM.gif' name='submit' alt='PayPal - The safer, easier way to pay online!' />
        <img alt='' src='https://www.paypalobjects.com/en_US/i/scr/pixel.gif' width='1' height='1' />
      </form>
    let myResultsButton = () => {
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {paypalDonationButton()}
          <span className='btn-results' onClick={() => this._handleMyResultsOnClick()}>My Results</span>
        </div>
      )
    }
    let account = () =>
      <div>
        <input
          type='email'
          placeholder='my@email.com'
          onChange={(e) => this.setState({accountCheck: e.target.value})}
          onBlur={() => this.setState({showAccountInput: false})}
          onKeyPress={(event) => { if (event.key === 'Enter') { this._accountCheck() } }}
          className={'account-input'}
          value={this.state.accountCheck}
          autoFocus />
        <a className='btn-results' onMouseDown={() => this._accountCheck()}>Check</a>
      </div>
    let accountButton = () =>
      <span className='btn-results' onClick={() => this.setState({showAccountInput: true})}>{this.props.account}</span>

    if (this.state.showAccountInput) {
      return account()
    } else if (this.props.account === undefined) {
      return myResultsButton()
    } else {
      return accountButton()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationBar/NavigatorResultChecker.js